import clsx from 'clsx';
import { forwardRef } from 'react';

import { Button, ButtonProps } from '../Button';
import { Link, LinkProps } from '../Link';

import styles from './ButtonLink.module.scss';

export type ButtonLinkProps = ButtonProps & Pick<LinkProps, 'href' | 'target' | 'rel' | 'isOutsideLink'>;

export const ButtonLink = forwardRef<HTMLButtonElement, ButtonLinkProps>((props, ref) => {
  const { className, href, target, rel, isOutsideLink, ...buttonProps } = props;

  return (
    <Link className={clsx(styles.root, className)} href={href} target={target} rel={rel} isOutsideLink={isOutsideLink}>
      <Button className={styles.button} ref={ref} {...buttonProps} />
    </Link>
  );
});

ButtonLink.displayName = 'ButtonLink';
